// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__17ra4","validationTips":"StatementDescriptor_validationTips__3cOxT"};